module.exports = __webpack_public_path__ + "img/initPage.cc2d4bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/initPage.jpg
// module id = ZiIH
// module chunks = 148